import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRightIcon } from 'lucide-react';
interface ProjectCardProps {
  title: string;
  subtitle: string;
  index: number;
  mockupType?: 'dashboard' | 'mobile';
  mediaUrl?: string;
  mediaType?: 'image' | 'video';
  onClick?: () => void;
  comingSoon?: boolean;
}
export function ProjectCard({
  title,
  subtitle,
  index,
  mockupType,
  mediaUrl,
  mediaType,
  onClick,
  comingSoon = false
}: ProjectCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 40
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.8,
    delay: index * 0.1,
    ease: [0.19, 1, 0.22, 1]
  }} className={`group flex flex-col gap-6 ${comingSoon ? 'cursor-default' : 'cursor-pointer'}`} onClick={comingSoon ? undefined : onClick} data-id="element-46" data-mp="2liyaxobx45xy">
      <motion.div whileHover={{
      scale: 1.02
    }} transition={{
      duration: 0.4,
      ease: [0.19, 1, 0.22, 1]
    }} className={`w-full aspect-[4/3] bg-stone-light rounded-2xl overflow-hidden relative flex items-center justify-center shadow-sm group-hover:shadow-md transition-shadow ${!mediaUrl ? 'p-8 md:p-12' : ''}`} data-id="element-47" data-mp="v8vepo4wjbvo">
        {mediaUrl ? mediaType === 'video' ? <video src={mediaUrl} autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-48" data-mp="aivx09pmghbu" /> : <img src={mediaUrl} alt={title} className="w-full h-full object-cover" data-id="element-49" data-mp="5goef1aae30j" /> : mockupType === 'dashboard' ? <div className="w-full h-full bg-white rounded-xl shadow-sm border border-stone-border flex flex-col overflow-hidden" data-id="element-50" data-mp="kdxm55jwdjef">
            {/* Header */}
            <div className="h-12 border-b border-stone-border flex items-center px-4 gap-4" data-id="element-51" data-mp="t8bwquthg5r7">
              <div className="w-3 h-3 rounded-full bg-stone-border" data-id="element-52" data-mp="p6gv1p7n3qcw" />
              <div className="w-3 h-3 rounded-full bg-stone-border" data-id="element-53" data-mp="p8l04ah9yver" />
              <div className="w-3 h-3 rounded-full bg-stone-border" data-id="element-54" data-mp="136hyncfahbw2" />
              <div className="ml-auto w-24 h-4 bg-stone-light rounded" data-id="element-55" data-mp="y7okriw3bivd" />
            </div>
            {/* Body */}
            <div className="flex-1 flex p-4 gap-4" data-id="element-56" data-mp="3rzwp5ylozeqs">
              {/* Sidebar */}
              <div className="w-1/4 flex flex-col gap-3" data-id="element-57" data-mp="3vzoywemtnqxq">
                <div className="w-full h-6 bg-stone-light rounded" data-id="element-58" data-mp="3vy42ejgy5xx8" />
                <div className="w-3/4 h-4 bg-stone-light rounded" data-id="element-59" data-mp="4sm7pn6zhkni" />
                <div className="w-5/6 h-4 bg-stone-light rounded" data-id="element-60" data-mp="9l5kihxukbr9" />
                <div className="w-4/5 h-4 bg-stone-light rounded" data-id="element-61" data-mp="ejyz6dove8t0" />
              </div>
              {/* Main Content */}
              <div className="flex-1 flex flex-col gap-4" data-id="element-62" data-mp="jijzed44gshg">
                <div className="w-1/3 h-8 bg-stone-light rounded" data-id="element-63" data-mp="jl65s9fa11y3" />
                <div className="w-full h-32 bg-stone-light rounded-lg" data-id="element-64" data-mp="nlyhrafj9ky2" />
                <div className="flex gap-4" data-id="element-65" data-mp="sk9q1gq6jne6">
                  <div className="flex-1 h-24 bg-stone-light rounded-lg" data-id="element-66" data-mp="siym9gwqifn2" />
                  <div className="flex-1 h-24 bg-stone-light rounded-lg" data-id="element-67" data-mp="2pdbkptxxxirh" />
                </div>
              </div>
            </div>
          </div> : <div className="h-full aspect-[9/19] bg-white rounded-[2rem] shadow-sm border-[6px] border-stone-border flex flex-col overflow-hidden relative" data-id="element-68" data-mp="2ucxxy3drqz0a">
            {/* Notch */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/3 h-4 bg-stone-border rounded-b-xl" data-id="element-69" data-mp="2hzkevj4m4e6g" />
            {/* Content */}
            <div className="flex-1 p-4 pt-8 flex flex-col gap-4" data-id="element-70" data-mp="282z92vkrqz1k">
              <div className="w-1/2 h-6 bg-stone-light rounded" data-id="element-71" data-mp="280mixv4uxidf" />
              <div className="w-full h-32 bg-stone-light rounded-xl" data-id="element-72" data-mp="35peolrtmxmmh" />
              <div className="w-full h-12 bg-stone-light rounded-lg" data-id="element-73" data-mp="30qv47vuowiw8" />
              <div className="w-full h-12 bg-stone-light rounded-lg" data-id="element-74" data-mp="30pk1lzczdh6p" />
              <div className="w-full h-12 bg-stone-light rounded-lg" data-id="element-75" data-mp="2vqp9g6t4ig9x" />
            </div>
          </div>}
      </motion.div>

      <div className="flex justify-between items-start px-2" data-id="element-76" data-mp="2rsrhiw7yxg2u">
        <div data-id="element-77" data-mp="1kdwiuzc2jxvg">
          <h3 className="text-xl md:text-2xl font-bold text-ink mb-1" data-id="element-78" data-mp="1keoeub9kvxm9">
            {title}
          </h3>
          <p className="text-stone-medium text-base" data-id="element-79" data-mp="1ga89cb3vms7k">{subtitle}</p>
        </div>
        {comingSoon ? <div className="px-3 py-1.5 rounded-full bg-stone-light opacity-0 group-hover:opacity-100 transform translate-y-2 group-hover:translate-y-0 transition-all duration-300" data-id="element-80" data-mp="346msmt01icsg">
            <span className="text-sm font-medium text-stone-medium whitespace-nowrap" data-id="element-81" data-mp="2ubctcd110jid">
              Coming soon
            </span>
          </div> : <div className="w-10 h-10 rounded-full bg-stone-light flex items-center justify-center opacity-0 group-hover:opacity-100 transform translate-y-2 group-hover:translate-y-0 transition-all duration-300" data-id="element-82" data-mp="2z6s4uybka3bm">
            <ArrowUpRightIcon className="w-5 h-5 text-ink" data-id="element-83" data-mp="3dy131vtj4x0d" />
          </div>}
      </div>
    </motion.div>;
}